<template>
    <rkm-modal
        extra-large
        hide-footer
        ref="RkmModal"
        title="Lista de logradouros"
    >
        <List
            :classificacao_id="classificacao_id"
            @select="handleExit"
            selection-mode
        />
    </rkm-modal>
</template>

<script>
// Components.
import List from '@/components/cadastro/logradouro/List'

export default {
    components: {List},
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        handleExit(logradouro) {
            this.$emit('select', logradouro)
            this.$refs.RkmModal.hide()
        },
    },
    props: {
        classificacao_id: {type: Number},
    },
}
</script>